module.exports = __webpack_public_path__ + "media/bootstrap-icons/arrow-up-left-square-fill-f97b1818.svg";